import { View, Platform, TouchableOpacity } from 'react-native';
import React from 'react';
import colors from '~/assets/themes/colors';
import Text from '~/components/Text';

interface Props extends Radio.Item {
  isSelected: boolean;
  onPress: (value: string) => void;
}

const Radio = ({ icon: Icon, label, value, isSelected, onPress }: Props) => {
  return (
    <TouchableOpacity activeOpacity={0.6} onPress={() => onPress(value)}>
      <View
        className={`py-7 px-4 flex-row justify-between rounded-md my-2 shadow border border-white bg-white ${
          Platform.OS === 'android' ? 'shadow-black/40' : ''
        } ${isSelected ? 'border border-primary-600' : ''}`}
      >
        <View className="flex-row space-x-2 flex-1">
          {!!Icon && (
            <Icon color={isSelected ? colors.primary[600] : colors.gray[600]} />
          )}

          <Text
            className={`text-sm text-gray-600 ${
              isSelected ? 'text-primary-600' : ''
            }`}
          >
            {label}
          </Text>
        </View>

        <View
          className={`h-5 w-5 rounded-xl border border-gray-300 items-center justify-center ml-2 ${
            isSelected ? 'bg-primary-200 border-primary-200' : ''
          }`}
        >
          {isSelected && (
            <View className="h-[10px] w-[10px] bg-primary-600 rounded-md" />
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default Radio;
